

















































































  import Vue from 'vue';
  import api from '../api';
  import axios from 'axios';
  import {AxiosRequestConfig} from 'axios';
  import {Form} from 'element-ui';
  import csrftoken from '../getToken';
  import gql from 'graphql-tag';

  export default Vue.extend({
    data() {
      const checkusername = async (rule: string, value: string, callback: (this: void, e: object | undefined) => void) => {
        if (!value) {
          return callback(new Error('用户名不能为空'));
        }
        if (typeof (value) !== 'string') {
          callback(new Error('请输入字符串'));
        } else {
          if (value.length > 16) {
            callback(new Error('用户名过长'));
          } else {
            const reg1 = /^[`\s~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/i;
            const reg2 = /\s/g;
            let res1 = reg1.test(value);
            const res2 = reg2.test(value);
            if (res1) {
              callback(new Error("不能以特殊符号开头"));
            } else if (res2) {
              callback(new Error("不能含空格"));
            }
            let validRes = await this.$apollo.query({
              query: gql`query {
                unoccupied(field:username,value:"${value}")
              }`,
              fetchPolicy: "no-cache"
            })
            if (!validRes.data.unoccupied) {
              callback(new Error("此用户名已经被注册"));
            } else {
              callback(undefined);
            }
          }
        }
      }
      const that = this;
      const validatePass = (rule: string, value: string, callback: (this: void, e: object | undefined) => void) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value.length >= 6 && value.length <= 16) {
          const reg1 = /\d/;
          const reg2 = /[a-zA-Z]/;
          if (!reg1.test(value) || !reg2.test(value)) {
            callback(new Error('需包含至少一个字母和至少一个数字'));
          } else {
            callback(undefined);
          }
        } else {
          if ((that as any).registerForm.password1 !== '') {
            (this.$refs.registerForm as any).validateField('checkPass');
          }
          callback(undefined);
        }
      };
      const validatePass2 = (rule: string, value: string, callback: (this: void, e: object | undefined) => void) => {
        if (value === '') {
          callback(new Error('请确认密码'));
        } else if (value !== (that as any).registerForm.password1) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback(undefined);
        }
      };
      const checkUnit = (rule: string, value: string, callback: (this: void, e: object | undefined) => void) => {
        if (typeof (value) !== "string") {
          callback(new Error('请输入字符串数据'));
        } else {
          if (value === '') {
            callback(new Error('请输入医院名称'));
          } else {
            callback(undefined);
          }
        }
      };
      // 检查电话号码是否合法
      const checkPhone = async (rule: string, value: string, callback: (this: void, e: object | undefined) => void) => {
        let self = this;
        if (typeof (value) !== "string") {
          callback(new Error('请输入字符串数据'));
        } else {
          if (value === '') {
            callback(new Error('请输入电话号码'));
          } else {
            if (!(/^1\d{10}$/.test(value))) {
              callback(new Error('电话号码格式不正确'));
            }
            let validRes = await this.$apollo.query({
              query: gql`query {
                unoccupied(field:phone,value:"${value}")
              }`,
              fetchPolicy: "no-cache"
            })
            if (!validRes.data.unoccupied) {
              callback(new Error("此手机号已经被注册"));
            } else {
              callback(undefined);
            }
          }
        }
      };
      return {
        // 全部禁用
        allDisabled: true,
        btnText: '获取验证码',
        disabled: true,
        timer: 0,
        // 按钮的类型
        typeText: 'primary',
        // 用户存在
        userExist: false,
        // 医院名称的数据
        // hospitalData: Object[],
        // 电话号码存在
        phoneExist: false,
        registerForm: {
          username1: "",
          password1: '',
          realname: '',
          phone: '',
          vcode: '',
          unit: '',
          checkPass1: '',
        },
        rules: {
          username1: [
            {required: true, validator: checkusername, trigger: 'change'},
            {min: 1, max: 16, message: '请输入用户名', trigger: 'change'}
          ],
          realname: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
            {min: 2, max: 64, message: '长度在 2 到 64 个字符', trigger: 'blur'},
          ],
          phone: [{required: true, validator: checkPhone, trigger: 'blur'}],
          email: [{message: '请输入邮箱地址', trigger: 'blur'}],
          password1: [
            {required: true, validator: validatePass, trigger: 'change'},
            {min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'change'},
          ],
          checkPass1: [
            {required: true, validator: validatePass2, trigger: 'change'},
          ],
          vcode: [
            {required: true, message: '请输入验证码', trigger: 'blur'},
          ],
          unit: [
            {required: true, validator: checkUnit, message: '请输入医院名称', trigger: 'blur'}
          ]
        },
      };
    },
    methods: {
      async submitForm() {
        const params = {
          username: this.registerForm.username1,
          password: this.registerForm.password1,
          realname: this.registerForm.realname,
          phone: this.registerForm.phone,
          vcode: this.registerForm.vcode,
          unit: this.registerForm.unit,
          from: 'PC'
        };
        try {
          // console.log("开始注册");
          let registerRes = await this.$apollo.mutate({
            // Query
            mutation: gql`mutation{
              doctorRegister(username: "${params.username}",
                              password: "${params.password}",
                              realname: "${params.realname}",
                              phone: "${params.phone}",
                              vcode: "${params.vcode}",
                              unit: "${params.unit}",
                              from: "PC"
                              )
            }`,
          })
          this.$message({
            type: "success",
            message: "注册成功"
          });
          let loginRes = await this.$apollo.mutate({
            // Query
            mutation: gql`mutation{
                    doctorLogin(namephone:"${params.username}",
                                password: "${params.password}",
                                from: "PC"
                                )
                  }`,
            fetchPolicy: "no-cache"
          });
          if (loginRes.data.doctorLogin === null) {
            sessionStorage.setItem('username', params.phone);
            this.$router.push({name: 'home'});
          }
        } catch (e) {
          let message = e.message.split(":")[1];
          this.$message.error(message);
        }
      },
      resetForm() {
        this.registerForm.password1 = '';
        this.registerForm.realname = '';
        this.registerForm.name = "";
        this.registerForm.phone = '';
        this.registerForm.vcode = '';
        this.registerForm.unit = '';
        this.registerForm.checkPass1 = '';
        this.registerForm.username1 = '';
      },
      async querySearch(queryString, callback) {
        if (queryString.length >= 3) {
          const response = await this.$apollo.query({
            query: gql`{
										hospitals(keyword:"${queryString}")
								}`,
          });
          const arr = response.data.hospitals;
          const newArr = arr.map(item => {
            return {
              value: item,
            }
          });
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            callback(newArr);
          }, 200);
        } else {
          callback([]);
        }
      },
      handleSelect(item) {
        // console.log(item);
      },
      async getCode() {
        this.disabled = true;
        let num = 60;
        let self = this;
        this.timer = window.setInterval(() => {
          num--;
          this.btnText = `${(num)}s后重新发送`;
          if (num <= 0) {
            num = 60;
            clearInterval(self.timer);
            self.btnText = '获取验证码';
            self.disabled = false;
            self.typeText = 'primary';
          }
        }, 1000);
        let phone = this.registerForm.phone;
        let codeRes = await this.$apollo.mutate({
          mutation: gql`mutation {
            sendVCode(phone: "${phone}")
          }`
        })
      },
      phoneNumChange(num) {
        // console.log('phoneNumber is--->',num);
      },
    },
    mounted() {
      this.registerForm.password1 = '';
      this.registerForm.realname = '';
      this.registerForm.name = "";
      this.registerForm.phone = '';
      this.registerForm.vcode = '';
      this.registerForm.unit = '';
      this.registerForm.checkPass1 = '';
      this.registerForm.username1 = '';
    },
    computed: {},
    watch: {
      'registerForm.phone'(newVal) {
        if (newVal.length === 11) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      }
    }
  });

